<template>
  <div>
    <table class="table table-hover ui-table ts-table">
      <thead>
        <tr>
          <th>{{ $t('homework.studentName') }}</th>
          <th>{{ $t('homework.sex') }}</th>
          <th>{{ $t('homework.score') }}</th>
          <th style="width:1%">{{ $t('homework.lock') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(homework, index) in resource"
          :key="index"
          @dblclick="correction(homework)"
        >
          <td>{{ homework.student.full_name_en }}</td>
          <td>{{ homework.student.gender }}</td>
          <td>{{ homework.score }}</td>
          <td class="text-center">
            <a href="#" @click.prevent="onLock(homework)">
              <a-icon type="sync" spin v-if="homework.action" />
              <div v-else>
                <a-icon type="lock" v-if="homework.is_accepted" />
                <a-icon type="unlock" v-else />
              </div>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'homeworkCorrectionStudentlist',
  props: ['value'],
  data() {
    return {
      resource: []
    }
  },
  created() {
    this.resource = this.value
  },
  methods: {
    correction(student) {
      this.$emit('selectedStudent', student)
    },
    onLock(record) {
      record.action = true
      this.$store
        .dispatch('eschool/homeworkCorrection/update', {
          id: record.student_homework_id,
          data: {
            is_accepted: record.is_accepted
          }
        })
        .then(response => {
          record.is_accepted = response.is_accepted
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          record.action = false
        })
    }
  },
  watch: {
    value: {
      handler(value) {
        if (value) {
          this.resource = value
        } else {
          this.resource = []
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="css" scoped>
table > tbody > tr {
  cursor: pointer;
}
</style>
